import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components/core/Typography';
import { Checkmark, CrossedCircle } from 'components/svg';

export function Amenity({ label, hasAttribute, display }) {
	return (display ? (
		<div className="amenity">
			{hasAttribute ? <Checkmark /> : <CrossedCircle />}
			<Text>{label}</Text>
		</div>
	) : null);
}

Amenity.propTypes = {
	label: PropTypes.string,
	hasAttribute: PropTypes.bool,
	display: PropTypes.bool
};

const EnhancedAmenity = ({ amenity: { hasAttribute, label, showAlways } }) => {
	const mappedProps = {
		label,
		hasAttribute,
		display: hasAttribute || showAlways,
	};
	return <Amenity {...mappedProps} />;
};

export default EnhancedAmenity;
